import { useAuth } from "@/contexts/auth/useAuth";
import { type Features, getFeatures } from "@/utils/features";

import { useInstance } from "./useInstance";

/** Get features for the current instance. */
export const useFeatures = (): Features => {
  const instance = useInstance();
  const { currentAccount } = useAuth();

  const features = getFeatures(instance);

  return {
    ...features,
    boosts: features.boosts && !!currentAccount?.features?.boosts,
    predictions:
      features.predictions && !!currentAccount?.features?.predictions,
    sports: features.sports && !!currentAccount?.features?.sports,
  };
};
